import React from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { FCWithChildren } from '@wix/challenges-web-library';
import { NewAccordion } from './NewAccordion';
import {
  TextAlignment,
  BidirectionalAlignment,
} from '../../components/ChallengesPage/Settings/challengeSettings/challengeSettings.types';

export interface IAccordionProps {
  title: React.ReactNode;
  disabled?: boolean;
  subtitle?: React.ReactNode;
  tooltipText?: string;
  tooltipDisabled?: boolean;
  prefixIcon?: React.ReactNode;
  'data-hook'?: string;
  opened?: boolean;
  forceOpened?: boolean;
  className?: string;
  align?: TextAlignment | BidirectionalAlignment;
  id?: string;
  onClick?: Function;
  onIconClick?(): void;
  buttonRole?: 'tab' | 'button';
  isEmpty?: boolean;
  withCSSAlignment?: boolean;
}

export const Accordion: FCWithChildren<IAccordionProps> = (props) => {
  const { isMobile, isRTL } = useEnvironment();
  const [opened, setOpened] = React.useState<boolean>(props.opened);

  React.useEffect(() => {
    setOpened(props.opened);
  }, [props.opened]);

  React.useEffect(() => {
    /*
      This is fckn awesome.
      We need an ability to open the accordion manually from outside.
      So the `opened` prop isn't working here, because the accordion can be closed by internal state,
       but the `opened` prop will still be `true`.
      And we need one more `super opened` prop to handle it, and it should works only for one direction (`false` to the `true`),
        and don't close the accordion in other direction.
     */
    if (props.forceOpened) {
      setOpened(true);
    }
  }, [props.forceOpened]);

  const toggleOpen = () => {
    if (props.disabled) {
      return;
    }
    setOpened(!opened);

    if (props.onClick) {
      props.onClick();
    }
  };

  // Always use NewAccordion implementation
  return (
    <NewAccordion
      {...props}
      isMobile={isMobile}
      toggleOpen={toggleOpen}
      opened={opened}
      isRTL={isRTL}
    />
  );
};
